import {URL_API} from "../../url.config";
import {request} from "../../utils/apiUtils";
let ClassRoomController = {
    list: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/classroom/list`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    create: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/classroom/create`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    edit: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/classroom/edit`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    search: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/classroom/search`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    detail: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/classroom/detail/${id}`,
            method: 'GET'
        }, callback)
    },
    delete: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/classroom/delete/${id}`,
            method: 'GET'
        }, callback)
    },
    listLenLop: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/classroom/list-lenlop`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    ketChuyenLenLop: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/classroom/ketchuyen-lenlop`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    ketChuyenHocSinh: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/classroom/ketchuyen-hocsinh`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    ketChuyenHocSinhBack: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/classroom/ketchuyen-hocsinh-back`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    listHocSinh: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/classroom/list-hocsinh`,
            method: 'POST',
            body: payload,
        }, callback);
    },
}
export default ClassRoomController
